/**
 * Generates an array of subtle pastel colors using a limited set of base hues
 * with multiple shades of each for visual distinction.
 */
export function generateCategoryColors(count: number): string[] {
  // Base hues for pastel palette: blue, purple, pink, coral, yellow, green, teal
  const baseHues = [210, 260, 320, 15, 45, 140, 180];

  const colors: string[] = [];

  for (let i = 0; i < count; i++) {
    // Cycle through base hues
    const hueIndex = i % baseHues.length;
    const hue = baseHues[hueIndex];

    // Calculate shade variation within each hue
    const shadeLevel = Math.floor(i / baseHues.length);

    // Pastel colors: low saturation (40-65%), high lightness (65-80%)
    const saturation = 40 + (shadeLevel % 3) * 10; // 40%, 50%, 60%
    const lightness = 65 + (shadeLevel % 2) * 8; // 65%, 73%

    colors.push(`hsl(${hue}, ${saturation}%, ${lightness}%)`);
  }

  return colors;
}
